export type FrontendConfig = {
  apiBaseUrl: string
  middlewareApiBaseUrl: string
  middlewareWebviewToken: string
  contextPath: string
  stepPath: string
  signingPath: string
  middlewarePaths?: Partial<import('./middleware-api.js').MiddlewareApiPaths>
}

const DEFAULT_API_BASE_URL = 'https://at-product-family-econtract-api.dev.oneat.org'
const runtime = (): ESignRuntimeConfig => (typeof window !== 'undefined' ? window.__ESIGN_CONFIG__ ?? {} : {})

export function frontendConfig(): FrontendConfig {
  const config = runtime()
  const apiBase = config.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL
  const middlewareBase =
    config.MIDDLEWARE_API_BASE_URL || import.meta.env.VITE_MIDDLEWARE_API_BASE_URL || apiBase || DEFAULT_API_BASE_URL

  return {
    apiBaseUrl: apiBase,
    middlewareApiBaseUrl: middlewareBase,
    middlewareWebviewToken:
      (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('dev_webview_token') : null) ||
      config.MIDDLEWARE_WEBVIEW_TOKEN ||
      import.meta.env.VITE_MIDDLEWARE_WEBVIEW_TOKEN ||
      '',
    contextPath: config.CONTEXT_PATH || import.meta.env.VITE_CONTEXT_PATH || '/s/:sessionId/v1/context',
    stepPath: config.STEP_PATH || import.meta.env.VITE_STEP_PATH || '/s/:sessionId/v1/steps/:step',
    signingPath: config.SIGNING_PATH || import.meta.env.VITE_SIGNING_PATH || '/s/:sessionId/:step',
    middlewarePaths: config.MIDDLEWARE_PATHS,
  }
}

export function expandPath(template: string, values: Record<string, string>): string {
  return template.replace(/:([A-Za-z][A-Za-z0-9_]*)/g, (_, key: string) => {
    const value = values[key]
    if (!value) throw new Error(`Thiếu tham số đường dẫn: ${key}`)
    return encodeURIComponent(value)
  })
}

export function apiUrl(path: string, config = frontendConfig()): string {
  const base = config.apiBaseUrl.replace(/\/$/, '')
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}

export function middlewareApiUrl(path: string, config = frontendConfig()): string {
  const base = (config.middlewareApiBaseUrl || config.apiBaseUrl).replace(/\/$/, '')
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}

export const signingUrl = (sessionId: string, step: string, config = frontendConfig()): string =>
  expandPath(config.signingPath, { sessionId, step })
